
import { mapState } from 'vuex';
import ReviewSort from '@/enums/ReviewSort';

const ORDERD_OPTIONS = [
  ReviewSort.RECENTLY_CREATED,
  ReviewSort.MOST_SCORES,
  ReviewSort.MOST_HELPS,
  ReviewSort.MOST_LIKES,
  ReviewSort.AI_RECOMMENDATION,
  ReviewSort.OLDEST_PURCHASE,
  ReviewSort.RECENTLY_PURCHASED,
  ReviewSort.EXPIRES_SOON
];

export default {
  name: 'ReviewSortDialog',
  computed: {
    ...mapState('window', ['windowService']),
    displayOrderOptions() {
      const display_orders_in_use = this.$route.query.display_orders_in_use;
      return display_orders_in_use.split(',').map(order => {
        const orderValue = parseInt(order);
        return {
          value: orderValue,
          name: ReviewSort.key(orderValue)
        };
      });
    },
    displayOrderMessages() {
      const mediaReviewsFirstMessage =
        this.$route.query.media_reviews_first === 'true'
          ? this.$t('search_bar.review_sort.message.media_reviews_first')
          : '';
      return ORDERD_OPTIONS.map(value => {
        const order = this.displayOrderOptions.find(o => o.value === value);
        if (order) {
          return this.$t(`search_bar.review_sort.message.${order.name}`, {
            media_reviews_first: mediaReviewsFirstMessage
          });
        }
        return null;
      }).filter(message => message);
    }
  },
  methods: {
    clickConfirm() {
      this.windowService.closeFullscreenPopup();
    }
  }
};
